import React from 'react';
import { Svg } from '../../Svg/Svg';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  label: string | React.ReactNode | React.ReactNode[];
  name: string;
  value?: string;
  errorMessage?: string;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isKMI?: boolean;
  noLabelStyle?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({
  id,
  label,
  name,
  value,
  errorMessage,
  checked,
  onChange,
  isKMI,
  noLabelStyle,
  ...otherProps
}) => {
  console.log(isKMI);
  
  return (
    <div className="mz-form-item mz-form-item--checkbox">
      <label className="mz-form-item__inner" htmlFor={id}>
        {noLabelStyle ? (
          <div>{label}</div>
        ) : (
          <div className={!noLabelStyle ? 'mz-form-item__label-content' : ''}>
            {isKMI ? (
              <span className="text--white">{label}</span>
            ) : (
              label
            )}
          </div>
        )}
        <input
          type="checkbox"
          className="mz-form-item__checkbox"
          id={id}
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          {...otherProps}
        />
        <div className="mz-form-item__checkmark">
          <Svg
            type="checkmark"
            size={1}
            colour="mz-svg--black"
          />
        </div>
        {errorMessage && (
          <div className="mz-form-item__error-message">{errorMessage}</div>
        )}
      </label>
    </div>
  );
};

export default Checkbox;
